import { COLOR_PALETTE } from 'constants/ui';

export const activityBarStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '6px',
  paddingTop: '4px',
  paddingBottom: '4px',
};

export const activityIconStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: COLOR_PALETTE.BLUE[7],
};

export const activityIconPulseStyles = {
  ...activityIconStyles,
  animation: 'activityPulse 1.5s ease-in-out infinite',
  '@keyframes activityPulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },
};

export const activityTextStyles = {
  background: `linear-gradient(90deg, ${COLOR_PALETTE.BLUE[7]}, ${COLOR_PALETTE.BLUE[4]}, ${COLOR_PALETTE.GRAY[6]}, ${COLOR_PALETTE.BLUE[7]})`,
  backgroundSize: '300% 100%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: 'activityGradientShift 4s ease-in-out infinite',
  '@keyframes activityGradientShift': {
    '0%': { backgroundPosition: '0% 50%' },
    '50%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
};

export const activityTextIdleStyles = {
  color: 'text.secondary',
};
